<template>
  <v-layout row wrap>
    <v-flex
      xs8
      sm9
      py-0
      class="label--container">
      <span v-if="label" class="label" :class="{ reverted: isReverted }">{{label}}:
        <v-icon @click="$emit('iconClick')" v-if="icon">{{icon}}</v-icon>
      </span>
    </v-flex>

    <v-flex
      xs4
      sm3
      py-0
      class="value--container">
      <slot />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    isReverted: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

.label--container,
.value--container {
  text-align: right;
}

.label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: $typography-weight-bold;
}

.reverted {
  justify-content: flex-start;
  flex-direction: row-reverse;
}
</style>
